import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setShiftListsActions,
  setShiftDeletCall,
  SetShiftSearchActions,
  setClientBranchActions,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import ShiftCreateForm from "./ShiftCreateForm";
import Select from "react-select";
import "../../../StyleSheet/MainComponent/Shift/Shifts.scss";
const Shift = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [dtpagesize, setdtPagesize] = useState(10);
  const [currentPageShift, setCurrentPage] = useState(1);
  const [dataShift, setDatas] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [search, setsearch] = useState("");
  const [newpages, setNewpage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [DeleteID, setDeleteID] = useState("");
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [EditPopup, setEditpopup] = useState(false);
  const [EditIDSHIFT, setEditID] = useState("");
  const [ShiftSear, setSearch] = useState("");
  useEffect(() => {
    const payloads = {
      search: "",
      page_size: dtpagesize,
      page: currentPageShift,
    };
    dispatch(setShiftListsActions(payloads));
    console.log(
      state.ShiftList.ShiftLists,
      "states",
      state.ShiftList.Total_Count
    );
    setDatas(state.ShiftList.ShiftLists);
  }, [currentPageShift]);

  const handleNext = (next) => {    
    setCurrentPage(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
  setCurrentPage(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setCurrentPage(previous);

}
};
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  //----Shift------Search---Panginations

 

  // -----Search------------------------
  function tochange(e) {
    console.log("ee", e);
    setsearch(e);
    if (e != undefined && e != "") {
      const payload = {
        search: e,
        page_size: dtpagesize,
        page: 1,
      };
      dispatch(setShiftListsActions(payload));
      console.log(state.ShiftList.ShiftLists, "ioioioio");
    }
    if (e == "" || search == "") {
      const payload = {
        search: "",
        page_size: dtpagesize,
        page: 1,
      };
      dispatch(setShiftListsActions(payload));
      console.log(dataShift, "datsas");
    }
  }
  ///---Search----Shifts------------------------------
  function toSearchShiftchange(e) {
    console.log("eesas", e);
    if (state.ShiftSearch.ShiftSearch != undefined) {
      setSearch(e);
      if (e != undefined && e != "") {
        const payload = {
          search: e,
          page_size: dtpagesize,
          page: 1,
        };
        dispatch(SetShiftSearchActions(payload));
        //console.log(state.ShiftList.ShiftLists ,"ioioioio");
      }
      if (e == "" || ShiftSear == "") {
        const payload = {
          search: "",
          page_size: dtpagesize,
          page: 1,
        };
        dispatch(SetShiftSearchActions(payload));
        console.log(dataShift, "datsas");
      }
    }
  }

  const handlePageChange = (newPage) => {
    if (newPage < state.ShiftList.Total_Count) {
      setCurrentPage(newpages + 1);

      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 10,
        page: newPage,
      };
      dispatch(setShiftListsActions(pageEntries));
    }
  };

  const HandelDelete = () => {
    if (DeleteID != undefined) {
      console.log(currentPageShift, "sdsd");
      const payload = {
        DeleteID: DeleteID,
        currentPageShift: currentPageShift,
      };
      dispatch(setShiftDeletCall(payload, setDeletePOPUP(false)));
    }
  };
  const [Client, setClientBranch] = useState([]);
  const [MultiselectBranch, setMUltiselectBranch] = useState([]);
  const [branchName, setOptionsBranch] = useState([]);
  const [datas, SetDataid] = useState({ client_id: "" });
  const [ShiftSearch, setShiftSearch] = useState([]);
  useEffect(() => {
    console.log(datas, "33");
    const payloads = {
      search: "",
      page_size: dtpagesize,
      page: currentPageShift,
      client_id: datas,
    };
    dispatch(SetShiftSearchActions(payloads));
    setShiftSearch(state.ShiftSearch.ShiftSearch);
    setDatas(state.ShiftSearch.ShiftSearch);
    console.log(
      state.ShiftSearch.ShiftSearch,
      "satetaf",
      state.ShiftSearch.Total_Count
    );
  }, [datas.client_id]);

  ///-----------Client----------------
  useEffect(() => {
    const payloads = {
      search: "",
      page_size: 10,
      page: 1,
    };
    dispatch(setClientBranchActions(payloads));
    setClientBranch(state.ClientBranch.ClientBranchess);
    if (state.ClientBranch.ClientBranchess != undefined) {
      console.log(state.ClientBranch.ClientBranchess, "clientslists");
    }
    console.log(state.ClientBranch.ClientBranchess.client_id, "states");
  }, []);

  ///----------Clients-------------
  useEffect(() => {
    const Datas = [];
    setClientBranch(state.ClientBranch.ClientBranchess);
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      console.log(state.ClientBranch.ClientBranchess, "client");
      state.ClientBranch.ClientBranchess.forEach((element) => {
        // console.log(element.client_id                    ,"elementss", element);
        objectArray.push({ value: element.id, label: element.client_name });
      });

      setOptionsBranch(objectArray);
    }
    console.log(branchName, "names");
  }, []);
  ////------------___CLient
  const handleBranchNames = (selectedVal) => {
    setMUltiselectBranch(selectedVal);
    //setOptionsBranch(selectedVal)
    SetDataid({
      ...datas,
      client_id: selectedVal.value,
    });
    console.log(datas, "00000");
    // SetData({
    //     ...data,
    //     Client_id: selectedVal.value
    // })
  };

  const columns = [
    {
      Header: "Shift",
      accessor: "shift_name",
    },

    {
      Header: "Start Time ",
      accessor: "from_time ",
      Cell: (row) => {
        return (
          <>
            <div className="Create-Date">
              <div
                style={{ marginTop: "3px" }}>
                <span>
                  {" "}
                  {String(row.row.original.from_time.split("T")[0])}{" "}
                </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "End Time ",
      accessor: "end_time ",
      Cell: (row) => {
        return (
          <>
            <div className="Create-Date">
              <div
                style={{ marginTop: "3px" }}>
                <span> {String(row.row.original.end_time.split("T")[0])} </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{ display: "flex",justifyContent: "flex-start", gap: "5px" }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  setEditID(row.row.original.id);
                  setEditpopup(true);
                }}
              >
                <span>
                  {" "}
                  Edit{" "}
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span>
                  {" "}

                  Delete{" "}
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="Header-Details">
          <div className="InnerUsers">
            <h3>Shift</h3>
          </div>
        </div>
        <div
          className="row ShiftSelects"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "20px",
          }}
        >
          <div className="col-4 mt-3">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontFamily: "Mediumweight" }}
            >
              Client Name
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMUltiselectBranch(e)}
              onRemove={(e) => setMUltiselectBranch(e)}
              onChange={(e) => {
                handleBranchNames(e);
              }}
              options={branchName}
              labelledBy="Select"
            />
          </div>
        </div>

        {dataShift != undefined ? (
          <div style={{ padding: "40px" }}>
            <ReactTable
              data={state.ShiftList.ShiftLists}
              columns={columns}
              totalItems={state.ShiftList.Total_Count}
              currentPage={currentPageShift}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              dtpagesize={pageSize}
              dtpageindex={currentPageShift}
              pageindex={pageindex}
              datacount={state.ShiftList.Total_Count}
              Oncreate={(e) => {
                window.location.href = "/shiftCreate";
                setEditID("");
              }}
            />
          </div>
        ) : null}
      
      </div>

      {EditPopup ? (
        <ShiftCreateForm
          EditId={EditIDSHIFT}
          currentPageShift={currentPageShift}
        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandelDelete}
        />
      ) : null}
    </>
  );
};

export default Shift;
